import React, { useEffect, useState } from 'react'
import { Row, Col, Container, Spinner } from 'react-bootstrap'
import FormatDate from '../../formatters/FormatDate'
import { GeneralInformationGet } from '../../api/OrderResults/GeneralInformationGet'
import GeneralInformation from '../../api/OrderResults/OrderResultModel/GeneralInformation'
import FormatError from '../../formatters/FormatError'
import { toast } from 'react-toastify'
import { Subscriber } from 'rxjs'
import { finalize } from 'rxjs/operators'

export interface DonorInfoProps {
  personID?: number,
  firstName?: string,
  lastName?: string,
  dateOfBirth?: Date,
  gender?: string
}

const DonorInfo = (props: DonorInfoProps) => {
  const { personID } = props

  const [loading, setLoading] = useState(false)
  const [person, setPerson] = useState<DonorInfoProps>({ ...props })

  const formatGender = (gender: string = "") => {
    switch (gender) {
      case "M":
        return "Male"
      case "F":
        return "Female"
      default:
        return "Unknown"
    }
  }

  useEffect(() => {
    const sub = new Subscriber()
    if (!!personID) {
      setLoading(true)
      const sub = GeneralInformationGet(personID)
        .pipe(finalize(() => setLoading(false)))
        .subscribe(
          (data: GeneralInformation) => {
            setPerson({
              personID: data.PersonID,
              firstName: data.FirstName,
              lastName: data.LastName,
              dateOfBirth: !!data.DOB ? new Date(data.DOB) : undefined,
              gender: data.Gender
            })
          },
          error => toast.error(FormatError(error))
        )
    }
    return () => sub.unsubscribe()
  }, [personID])

  return (
    <Container fluid className='border-bottom py-1'>
      <Row>
        <Col className='border-right'>
          <h6>Donor Name:</h6>
          {loading ? <Spinner animation="border" size="sm" variant="light" /> : `${person.firstName} ${person.lastName}`}
        </Col>
        <Col className='border-right'>
          <h6>DOB:</h6>
          {loading ? <Spinner animation="border" size="sm" variant="light" /> : FormatDate(person.dateOfBirth)}
        </Col>
        <Col>
          <h6>Gender:</h6>
          {loading ? <Spinner animation="border" size="sm" variant="light" /> : formatGender(person.gender)}
        </Col>
      </Row>
    </Container>
  )
}

export default DonorInfo
